// extracted by mini-css-extract-plugin
export default {"footer":"footer__dAGPJA","rightButtons":"rightButtons__esws79"};